import { http } from '../axios';
import { shopPrefix } from '../../config';
import { useCopyBulkToSelectionList } from './useCopyToList';
import { ListSourceType } from '../../../models/ListSourceType';
import * as consts from '../../store/constants';
import { ExcludeProductSelection } from '../../shared/product-selection/ProductSelectionTypes';
import { useMutation } from '@tanstack/react-query';
import { TFunction } from 'i18next';
import { ErrorResponse, globalErrorResponse } from '../../shared/notification/actions';
import { useNavigate } from 'react-router-dom';

const createList = async ({
    sourceListName,
    t
}: {
    sourceListName: string;
    t: TFunction;
}): Promise<{ id: string; newListName: string }> => {
    const newListName = t('notifications.duplicateList.newName', {
        listName: sourceListName,
        defaultValue: ''
    });

    const res = await http.post(`${shopPrefix}/v1/selectionlists`, { listName: newListName });
    return { id: res.data, newListName };
};

export function useDuplicateListMutation({ sourceListId }: { sourceListId: string }) {
    const navigate = useNavigate();

    const allSelected: ExcludeProductSelection = {
        excluded: [],
        totalCount: 0
    };

    const { copyToListBulk: copyBulkProductsToList } = useCopyBulkToSelectionList({
        filter: {},
        source: ListSourceType.SELECTION_LIST,
        sourceSelectionListId: sourceListId,
        productSelection: allSelected
    });

    return useMutation(createList, {
        onSuccess: data => {
            const newListId = data.id;
            copyBulkProductsToList(newListId, false)
                .then(() => {
                    navigate(`${consts.PATH_SELECTIONLISTS}/${newListId}`);
                })
                .catch(error => {
                    return Promise.reject(error);
                });
        },
        onError: (error: ErrorResponse) => {
            globalErrorResponse(error);
        }
    });
}
